import type { URLSearchParamsInit } from 'react-router';
import { createSearchParams } from 'react-router';
import { projectSwitcherResetEnvironments } from '@gonfalon/dogfood-flags/dogfood-flags';

// View keys are scoped to a single project. Carrying them across a project
// switch produces filters for views that don't exist in the target project,
// which the backend rejects.
const projectScopedParams = ['selected-view', 'view'];

// Environment keys that happen to exist in both projects pass validation in the
// target project's loader, which then persists them as its saved selection.
const environmentParams = ['env', 'selected-env'];

/**
 * Removes search params that reference project-scoped entities so they don't
 * leak across a project switch.
 * @param searchParams anything that can be passed to URLSearchParams constructor
 * @returns sanitized search params, or undefined if none were provided
 */
export function withoutProjectScopedSearchParams(searchParams?: URLSearchParamsInit) {
  if (!searchParams) {
    return searchParams;
  }

  const nextSearchParams = createSearchParams(searchParams);
  for (const name of projectScopedParams) {
    nextSearchParams.delete(name);
  }
  if (projectSwitcherResetEnvironments()) {
    for (const name of environmentParams) {
      nextSearchParams.delete(name);
    }
  }
  return nextSearchParams;
}
